import { useAppSelector } from '@/store/hooks';
import { selectSaveId } from '@/store/slices/project/selectors';
import { EPaletteModes } from '@/types/theme-packs.types';
import Button from '@ui/buttons/button/button';
import Container from '@ui/container/container';
import Icon from '@ui/icons/icon';
import { ICONS } from '@ui/icons/types';
import styles from './theme-mode-toggle.module.css';

type TThemeModeToggleProps = {
  activeMode: EPaletteModes;
  onChange: (mode: EPaletteModes) => void;
};

const ThemeModeToggle = ({ activeMode, onChange }: TThemeModeToggleProps) => {
  const saveId = useAppSelector(selectSaveId);

  const isDarkMode = activeMode === EPaletteModes.Dark;
  const isSaving = saveId === 'theme-pack-save';

  const handleClick = () => {
    if (isSaving) return;
    const mode = activeMode === EPaletteModes.Dark ? EPaletteModes.Light : EPaletteModes.Dark;
    onChange(mode);
  };

  return (
    <Button
      border="2px solid var(--gray-700)"
      data-component="ThemeModeToggle"
      onClick={handleClick}
      aria-disabled={isSaving}
      position="relative"
      className="clear-button flex ai-center jc-center gap-4 padding-2 radius-100"
      backgroundColor={isDarkMode ? 'var(--gray-900)' : 'var(--gray-700)'}
      hoverBackgroundColor={isDarkMode ? 'var(--gray-700)' : 'var(--gray-800)'}
    >
      <Container className={`${styles.thumb}${isDarkMode ? ` ${styles.thumbDark}` : ''}`} />
      <Container
        height="24px"
        width="24px"
        borderRadius="100%"
        className="flex ai-center jc-center overflow-hidden position-relative"
      >
        <Icon size={16} color={isDarkMode ? 'var(--gray-600)' : 'var(--gray-200)'} name={ICONS.SUN_FULL} />
      </Container>
      <Container height="24px" width="24px" borderRadius="100%" className="flex ai-center jc-center overflow-hidden">
        <Icon size={10.67} color={isDarkMode ? 'var(--gray-200)' : 'var(--gray-600)'} name={ICONS.MOON_CRESCENT} />
      </Container>
    </Button>
  );
};

export default ThemeModeToggle;
